export default "__VITE_ASSET__DhcFn2td__"